import { serverText } from "../../i18n/localized";
import type { RoleInfo } from "../../api/users";
import type { Role } from "../../api/types";

/** A plain select over the server's role catalogue; labels never live in the SPA. */
export function RoleSelect({
  id,
  value,
  roles,
  onChange,
  onCancel,
  ariaLabel,
  disabled,
  autoFocus,
}: {
  id: string;
  value: Role;
  roles: RoleInfo[];
  onChange: (role: Role) => void;
  onCancel?: (() => void) | undefined;
  ariaLabel?: string | undefined;
  disabled?: boolean | undefined;
  autoFocus?: boolean | undefined;
}) {
  return (
    <select
      id={id}
      className="select"
      value={value}
      aria-label={ariaLabel}
      disabled={disabled}
      autoFocus={autoFocus}
      onChange={(event) => onChange(event.target.value as Role)}
      onKeyDown={(event) => {
        if (event.key === "Escape" && onCancel) {
          event.stopPropagation();
          onCancel();
        }
      }}
    >
      {roles.map((role) => (
        <option key={role.key} value={role.key}>
          {serverText(`domain.role.${role.key}.name`, role.name)}
        </option>
      ))}
    </select>
  );
}
